import { StrictMode, Suspense, lazy, useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes, useParams } from 'react-router-dom'
import '@fontsource-variable/inter'
import '@fontsource-variable/nunito'
import '@fontsource-variable/space-grotesk'
import '@fontsource-variable/source-serif-4'
import { get } from './lib/api'
import { PublicSite } from './public/PublicSite'
import './base.css'

// Le back-office est chargé à la demande : un visiteur du site public ne
// télécharge jamais l'éditeur.
const Landing = lazy(() => import('./landing/Landing').then((m) => ({ default: m.Landing })))
const AdminApp = lazy(() => import('./admin/AdminApp').then((m) => ({ default: m.AdminApp })))

function SlugSite() {
  const { slug = '' } = useParams()
  return <PublicSite slug={slug} base={`/p/${slug}`} />
}

/**
 * Racine : sur un domaine propre, la publication correspondante ; sur le
 * domaine de la plateforme, la page de présentation de Publiqa.
 */
function Root() {
  const [state, setState] = useState<{ slug: string } | { landing: true } | null>(() => {
    // Domaine propre : la page envoyée par le serveur nomme déjà le site.
    const meta = document.querySelector<HTMLMetaElement>('meta[name="publiqa-site"]')
    return meta?.content && meta.dataset['base'] === '' ? { slug: meta.content } : null
  })
  useEffect(() => {
    if (state) return
    get<{ slug: string }>(`/public/resolve?host=${encodeURIComponent(location.hostname)}`)
      .then((r) => setState({ slug: r.slug }))
      .catch(() => setState({ landing: true }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!state) return null
  if ('slug' in state) return <PublicSite slug={state.slug} base="" />
  return (
    <Suspense fallback={null}>
      <Landing />
    </Suspense>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={null}>
              <AdminApp />
            </Suspense>
          }
        />
        <Route path="/p/:slug/*" element={<SlugSite />} />
        <Route path="/*" element={<Root />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
)
